/**
* @prop --uic-header-menu-bg-color: default background color
* @prop --uic-header-menu-bg-color-secondary: background color for variant `secondary`
* @prop --uic-header-menu-text-color: default text and icon color
*/
uic-header-menu {
  background-color: var(--uic-header-menu-bg-color);
  color: var(--uic-header-menu-text-color);
  display: block;
  position: relative;

  .uic-header-menu__inner {
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
}

.uic-header-menu {
  &--secondary {
    background-color: var(--uic-header-menu-bg-color-secondary);
  }
}

.uic-header-menu {
  &--vertical {
    .uic-header-menu__inner {
      align-items: stretch;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }

    uic-header-menu-item {
      justify-content: flex-start;
    }
  }
}
